import { Tabs } from "antd";
import styled from "styled-components";

export const transitionTime = 250;

export const StyledDialogueBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const StyledDialogueTabs = styled(Tabs)`
  position: relative;
  margin-bottom: 20px;

  & .ant-tabs-nav {
    margin-bottom: 0;
  }

  & .ant-tabs-tab {
    margin: 0;
    padding: 0;
  }

  & .ant-tabs-tab-btn {
    padding: 5px 10px;
    text-transform: capitalize;
    color: var(--crm-grey);
    opacity: 0.7;
  }

  & .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--crm-grey);
    opacity: 1;
  }

  & .ant-tabs-content-holder {
    margin-top: 10px;
  }
`;
